import { UserInteractionHandlerTypes } from '../user-interaction-handler-types';
import { UserInteractionHandlerFactoryMethod } from './user-interaction-handler.factory-method';

export interface UserInteractionHandlerFactory<T extends keyof UserInteractionHandlerTypes> {
  create: UserInteractionHandlerFactoryMethod<T>;
}
